import React, { FC } from 'react';
import { Col, Row } from 'styled-bootstrap-grid';
import { useData } from '../use-data';
import { HomeImg, HomeReportHTMLContent } from './home.styled';
import { assetsPath } from '../const';
import { Box } from '@ch/common/components/box';

const HomeReport: FC = () => {
  const {
    data: {
      home: {
        reportInfo,
        images: {
          side: { url: imgUrl, altText },
        },
      },
    },
  } = useData();

  return (
    <Row>
      <Col md={imgUrl ? 7 : 12}>
        {reportInfo && <HomeReportHTMLContent dangerouslySetInnerHTML={{ __html: reportInfo }} />}
      </Col>
      {imgUrl && (
        <Col md={5}>
          <Box $m={[20, 0]}>
            <HomeImg src={`${assetsPath}/${imgUrl}`} alt={altText} />
          </Box>
        </Col>
      )}
    </Row>
  );
};

export default HomeReport;
